import React from 'react';
import BaseList from '@its/components/lib/Container components/ListContainer/BaseList';
import { getTemplates } from '../../api';
import { onSuccess } from './util';
import {
  UserPermissionContainer,
} from '@its/components/lib/Container components/UserContainer/UserPermissionContainer';
import {
  developer,
  admin,
} from '@its/components/lib/Container components/UserContainer/roles';

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.appBar = {
      title: 'TEMPLATES',
      navigateBack: false,
    };
    this.mapStateToProps = (state) => ({
      title: state.app.templates.list.title,
      columns: state.app.templates.list.columns,
      items: state.app.templates.list.items,
    });
  }

  render() {
    return (
      <UserPermissionContainer
        allowedRoles={[developer, admin]}
        showError
      >
        <BaseList
          mapStateToProps={this.mapStateToProps}
          route="template/add"
          appBar={this.appBar}
          request={getTemplates}
          onResult={onSuccess}
        />
      </UserPermissionContainer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Template/TemplateList.js
 **/